/* eslint-disable no-unused-expressions */
import React from 'react';
import moment from 'moment';
import { isJSON } from './formatter';
import { parseJSON } from './parser';

const getValueByKey = (customField, key) => {
  if (!customField) return '-';

  const customFields = JSON.parse(customField);
  const currentField = customFields?.find(obj => obj.key === key) || {};
  const { fieldType, value } = currentField;
  let response = '-';
  let label = response;

  const options = Array.isArray(value) ? value : [];

  if (options.length > 0) {
    response = '';

    if (fieldType === 'checkbox') {
      options?.forEach(option => {
        response = response + `${option.selected ? 'Ya' : 'Tidak'}`;
      });
    } else {
      options?.forEach(option => {
        if (option.selected) response = response + `${option.name}`;
      });
    }

    label = response;
  } else {
    response = value || '-';
    label = response;

    if (fieldType === 'file' || fieldType === 'image') {
      label = currentField?.[fieldType]?.filename || currentField?.[fieldType]?.title || value || '-';
    }
  }

  return {
    label,
    value: response
  };
};

/**
 * Function to append columns on custom field data to table
 * @param {Array} columns columns data from table
 * @param {Array} customForm custom form structure
 * @param {Boolean} pltPath special path
 * @param {number} indexSplice custom index field number
 */
export const addCustomFormColumns = (columns = [], customForm = [], pltPath, indexSplice) => {
  customForm.forEach(({ name, key, type }, idx) => {
    if (type === 'display') return;

    const findExistingField = columns.find(col => col.key === key);
    if (!findExistingField) {
      const column = {
        name,
        // selector: name,
        key,
        cell: row => {
          let fieldData = row.customeField?.data;

          if (pltPath) {
            fieldData = row.paymentLinkTransaction.customeField?.data;
          }

          const { label, value } = getValueByKey(fieldData, key);
          let response = value;

          switch (type) {
            case 'url':
              response =
                value !== '-' ? (
                  <div data-tag="___react-data-table-allow-propagation___" className="text-primary">
                    <a href={value} target="_blank" rel="noopener noreferrer" className="text-primary">
                      {label}
                    </a>
                  </div>
                ) : (
                  value
                );
              break;
            case 'datetime':
              response = value && value !== '-' ? moment(value).format('D MMM YYYY') : value;
              break;
            default:
              break;
          }

          return response;
        },
        cellExport: row => {
          let fieldData = row.customeField?.data;

          if (pltPath) {
            fieldData = row.paymentLinkTransaction.customeField?.data;
          }

          const { value } = getValueByKey(fieldData, key);
          let response = value;

          switch (type) {
            case 'datetime':
              response = value && value !== '-' ? moment(value).format('D MMM YYYY') : value;
              break;
            default:
              break;
          }

          return response;
        }
      };

      if (indexSplice) columns?.splice(indexSplice + idx, 0, column);
      else columns?.push(column);
    }
  });
};

export const addUrlTrackingColumns = (columns, urlParamTracking) => {
  if (isJSON(urlParamTracking)) {
    parseJSON(urlParamTracking, []).forEach(param => {
      const column = {
        name: param,
        cell: row => {
          const trackingData = row.paymentLinkTransaction
            ? row.paymentLinkTransaction.urlParamTrackingData
            : row.urlParamTrackingData;

          let value = parseJSON(trackingData, {})?.[param] || '-';
          if (!value) value = '-';
          return value;
        },
        cellExport: row => {
          const trackingData = row.paymentLinkTransaction
            ? row.paymentLinkTransaction.urlParamTrackingData
            : row.urlParamTrackingData;

          let value = parseJSON(trackingData, {})?.[param] || '-';
          if (!value) value = '-';
          return value;
        }
      };

      columns?.push(column);
    });
  }
};

/**
 * Function to filter data table by date
 * @param {Array} data data table
 * @param {String} startDate start date
 * @param {String} endDate end date
 * @returns {Array} result
 */
export const filterDataByDate = ({ data, startDate, endDate }) => {
  let result = data;
  if (startDate && endDate) {
    const startTimestamp = new Date(startDate).valueOf();
    const endTimestamp = new Date(endDate).valueOf();

    result = data.filter(item => {
      const itemTimestamp = item.createdAt;
      return itemTimestamp >= startTimestamp && itemTimestamp <= endTimestamp;
    });
  }

  return result;
};

/**
 * Function to change date on query variables
 * @param {String} startDate start date
 * @param {String} endDate end date
 * @param {Object} queryVariables query variables
 * @param {Boolean} isFromGetBalanceHistoryListWithCertificate flag to check if from getBalanceHistoryListWithCertificate
 * @returns {Boolean} isDateChanged
 */
export const onChangeVariablesDate = ({
  startDate,
  endDate,
  queryVariables,
  isFromGetBalanceHistoryListWithCertificate
}) => {
  let isDateChanged = false;

  if (startDate && endDate) {
    isDateChanged = true;

    if (queryVariables.sortField === 'createdAt' && queryVariables.sortDirection === 'ASC') {
      queryVariables.search.createdAt = [{ operator: 'gt', value: new Date(startDate) }];
      if (endDate) {
        queryVariables.search.createdAt.push({ operator: 'lt', value: new Date(endDate) });
      }
    } else {
      queryVariables.search.createdAt = [{ operator: 'lt', value: new Date(endDate) }];
      if (startDate) {
        queryVariables.search.createdAt.push({ operator: 'gt', value: new Date(startDate) });
      }
    }
  }

  if (!startDate && !endDate) {
    isDateChanged = true;

    delete queryVariables.search.createdAt;

    if (isFromGetBalanceHistoryListWithCertificate) {
      queryVariables.search.createdAt = [];
    }
  }

  return isDateChanged;
};
